export default "__VITE_ASSET__N8VCKEPV__"